const PERCENTAGE_MULTIPLIER = 100;

export function convertToPercentage(value: number, roundDown = false): number {
  return roundDown
    ? Math.floor(value * PERCENTAGE_MULTIPLIER)
    : Math.round(value * PERCENTAGE_MULTIPLIER);
}
